var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"primary","outlined":"","loading":_vm.loading},on:{"click":function($event){return _vm.makeDownload()}}},[_c('v-icon',[_vm._v("mdi-download")]),_vm._v(" Baixar ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }